<template>
  <el-form :model="form" :rules="rules" ref="form" label-position="top" @submit.prevent.native="onSubmit('form')">
    <app-placeholder-horizontal :imageId="form.imageId" @upload="onUpload"/>
    <el-form-item label="Article title" prop="title">
      <el-input v-model="form.title"></el-input>
    </el-form-item>
    <el-form-item label="Attractive description in 280 characters" prop="desc">
      <el-input type="textarea" v-model="form.desc" rows="5"></el-input>
    </el-form-item>
    <el-form-item label="Content" prop="content">
      <el-input id="mde" type="textarea" v-model="form.content"></el-input>
    </el-form-item>
    <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
  </el-form>
</template>

<script>
import SimpleMDE from 'simplemde'
import AppPlaceholderHorizontal from '@/components/App/AppPlaceholderHorizontal'

export default {
  components: {
    AppPlaceholderHorizontal,
  },

  props: {
    article: Object,
  },

  data() {
    return {
      loading: false,
      form: {
        title: this.article.title,
        desc: this.article.desc,
        content: this.article.content,
        imageId: this.article.image_id,
      },
      rules: {
        'title': [
          { required: true, message: 'Enter the article title.', trigger: 'blur' },
        ],
        'desc': [
          { required: true, message: 'Enter the article description.', trigger: 'blur' },
          { min: 140, max: 280, message: 'Length should be 140 to 280.', trigger: 'blur' },
        ],
        'content': [
          { required: true, message: 'Enter the article content.', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    var mde = new SimpleMDE({ element: document.getElementById('mde') })
    mde.codemirror.on('change', () => {
      this.form.content = mde.value()
    })
  },
  methods: {
    async onSubmit(form) {
      this.loading = true
      this.$refs[form].validate(async valid => {
        if (!valid) {
          this.loading = false
          return false
        }
        try {
          var { data } = await this.$http.put(`/articles/${ this.$route.params.id }`, {
            title: this.form.title,
            desc: this.form.desc,
            content: this.form.content,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }
        this.$message.success(data.message)
      })
    },
    async onUpload(imageId) {
      try {
        var { data } = await this.$http.put(`/articles/${ this.$route.params.id }/image`, {
          image_id: imageId,
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }
      this.$message.success(data.message)
    },
  },
}
</script>
